import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import type { MessageOnlyResponse } from '../types/messageOnlyResponse';
import type MutationOptions from '../types/mutationOptions';
import {
  postErrorReport,
  type ErrorReportBody,
} from '@/utils/requests/support-message-requests';
import type { AxiosError } from 'axios';

const useCreateErrorReport = (
  options?: MutationOptions<MessageOnlyResponse, ErrorReportBody>
): UseMutationResult<
  MessageOnlyResponse,
  AxiosError<MessageOnlyResponse>,
  ErrorReportBody
> =>
  useMutation({
    mutationFn: (values: ErrorReportBody) => postErrorReport(values),
    ...options,
  });

export default useCreateErrorReport;
